import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type Context from '@alltrails/core/types/Context';

const initialState: Context = {
  currentUser: null,
  mobileBrowser: false,
  displayMetric: false,
  languageRegionCode: 'en-US',
  primaryAlgoliaIndexId: '',
  alertsAlgoliaIndexId: '',
  publicBaseUrl: ''
};

export const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setContext: (_, action: PayloadAction<Context>) => {
      return { ...action.payload };
    }
  }
});

export const { setContext } = contextSlice.actions;

export default contextSlice.reducer;
